import {
	Checkbox,
	type CheckboxControlProps,
	type CheckboxLabelProps,
	type CheckboxRootProps,
	Show,
	Text,
} from '@chakra-ui/react';
import type React from 'react';

interface ICheckboxLabelProps extends CheckboxLabelProps {
	children?: React.ReactNode;
	fontSize?: string;
}
interface ICheckboxControlProps extends CheckboxControlProps {
	children?: React.ReactNode;
	borderColor?: { base: string; _dark: string };
	bg?: string;
}

const CustomCheckbox = {
	Root: (props: React.ComponentProps<typeof Checkbox.Root>) => (
		<Checkbox.Root {...props} />
	),
	Label: (props: ICheckboxLabelProps) => (
		<Checkbox.Label {...props} />
	),
	Control: (props: ICheckboxControlProps) => <Checkbox.Control {...props} />,
	HiddenInput: (props: React.ComponentProps<typeof Checkbox.HiddenInput>) => (
		<Checkbox.HiddenInput {...props} />
	),
};

export interface FaceliftCheckboxProps extends CheckboxRootProps {
	checked: boolean;
	onCheckedChange: (checked: boolean) => void;
	label?: string;
	customIcon?: React.ReactNode;
	labelPosition?: 'left' | 'right';
	labelProps?: React.ComponentProps<typeof Text>;
}

const FaceliftCheckbox: React.FC<FaceliftCheckboxProps> = ({
	checked,
	onCheckedChange,
	label,
	labelProps,
	customIcon,
	labelPosition = 'right',
	...rest
}) => {
	return (
		<CustomCheckbox.Root
			checked={checked}
			onCheckedChange={(e: { checked: boolean }) =>
				onCheckedChange(!!e.checked)
			}
			cursor="pointer"
			{...rest}
		>
			<CustomCheckbox.HiddenInput />
			<Show
				when={labelPosition === 'right'}
				fallback={
					<>
						<Show when={label}>
							<CustomCheckbox.Label>{<Text {...labelProps}>{label}</Text>}</CustomCheckbox.Label>
						</Show>
						<Show
							when={customIcon}
							fallback={
								<CustomCheckbox.Control
									borderColor={{
										base: checked ? 'transparent' : '{colors.gray.700}',
										_dark: checked ? 'transparent' : '{colors.gray.300}',
									}}
									bg={checked ? 'brand.solidGradient' : 'transparent'}
								/>
							}
						>
							<CustomCheckbox.Control>{customIcon}</CustomCheckbox.Control>
						</Show>
					</>
				}
			>
				<Show
					when={customIcon}
					fallback={
						<CustomCheckbox.Control
							borderColor={{
								base: checked ? 'transparent' : '{colors.gray.700}',
								_dark: checked ? 'transparent' : '{colors.gray.300}',
							}}
							bg={checked ? 'brand.solidGradient' : 'transparent'}
						/>
					}
				>
					<CustomCheckbox.Control>{customIcon}</CustomCheckbox.Control>
				</Show>
				<Show when={label}>
					<CustomCheckbox.Label>{<Text {...labelProps}>{label}</Text>}</CustomCheckbox.Label>
				</Show>
			</Show>
		</CustomCheckbox.Root>
	);
};

export default FaceliftCheckbox;
